import { keyframes, styled } from "@mui/system";

export const FileDropzone = styled("div")((props: { error: boolean }) => {
  return {
    display: "flex",
    padding: "var(--spacing, 80px) 16px",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    borderRadius: "16px",
    border: props.error ? "1px solid #FC4C4C" : "1px dotted var(--neutral-100, #e5e7e8)",
    cursor: "alias",
  };
});

const fill = keyframes`
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
`;

const successAnimation = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
`;

const deletingAnimation = keyframes`
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
`;

export const UploadedItems = styled("div")(
  (props: { error: boolean; isUploading: boolean; isDeleting: boolean }) => {
    const { error, isUploading, isDeleting } = props;
    return {
      padding: "var(--spacing, 4px) 16px",
      alignItems: "center",
      flex: "1 0 0",
      borderRadius: "var(--spacing, 4px)",
      background: error ? "#FFF6F6" : "#F0FEF9",

      //   Font
      color: error ? "#FC4C4C" : "var(--primary-navy-blue-900-p, #002035)",
      textAlign: "center",
      fontFamily: "Söhne",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "17px",

      //   Loading Animation
      position: "relative",
      "::before": isUploading
        ? {
            content: '""',
            position: "absolute",
            top: "0",
            left: "0",
            height: "100%",
            width: "100%",
            backgroundColor: "rgba(0,0,0,0.1)",
            animation: `${fill} 2s linear infinite`,
          }
        : {},

      // Deleting Animation
      "::after": isDeleting
        ? {
            content: '""',
            position: "absolute",
            top: "0",
            left: "0",
            height: "100%",
            width: "100%",
            backgroundColor: "rgba(0,0,0,0.1)",
            animation: `${deletingAnimation} 2s linear infinite`,
          }
        : {},
      // Success Animation
      animation: !isUploading ? `${successAnimation} 0.5s ease-out` : "none",
    };
  },
);

export const HelperText = styled("p")({
  color: "var(--neutral-500, #002035)",
  fontSize: "14px",
  fontStyle: "normal",
  lineHeight: "14px",
  fontWeight: "normal",
});

export const StyledErrorMessage = styled("span")({
  color: "var(--primary-salmon-500-p, #FC4C4C)",
  textAlign: "left",
  fontFamily: "Söhne",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "14px",
});
